import { render } from "./PageHead.vue?vue&type=template&id=580aee1c"
import script from "./PageHead.vue?vue&type=script&lang=js"
export * from "./PageHead.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e81b44bb18c27249e199d595fb2f7252/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__